import {
	GeoTiffBandResultDto,
	GeoTiffBandInfo,
	GeoTiffBandData,
	GeoTiffMetadata,
} from '../dtos/GeoTiffBandResult.dto'

export class GeoTiffBandExtractorProvider {
	static async extract(file: File): Promise<GeoTiffBandResultDto> {
		const { fromBlob } = await import('geotiff')
		const tiff = await fromBlob(file)
		const image = await tiff.getImage(0)

		const width = image.getWidth()
		const height = image.getHeight()
		const bandCount = image.getSamplesPerPixel()
		const origin = image.getOrigin()
		const resolution = image.getResolution()
		const bbox = image.getBoundingBox()
		const noDataValue = image.getGDALNoData()

		const rasters = await image.readRasters()

		const bands: GeoTiffBandInfo[] = []

		for (let i = 0; i < bandCount; i++) {
			const bandData = rasters[i] as GeoTiffBandData
			const gdal = (await image.getGDALMetadata(i)) ?? {}
			const name = (gdal.DESCRIPTION as string) || `Band ${i + 1}`
			let min = Infinity
			let max = -Infinity

			for (let j = 0; j < bandData.length; j++) {
				const val = bandData[j]
				if (noDataValue !== null && val === noDataValue) continue
				if (val < min) min = val
				if (val > max) max = val
			}

			bands.push({
				index: i,
				name,
				data: bandData,
				min: min === Infinity ? 0 : min,
				max: max === -Infinity ? 0 : max,
				gdal,
				noDataValue,
			})
		}

		const geoKeys = image.getFileDirectory().parseGeoKeyDirectory()
		const isGeoreferenced = geoKeys !== null

		const metadata: GeoTiffMetadata = {
			width,
			height,
			bandCount,
			origin: [origin[0], origin[1]],
			resolution: [resolution[0], resolution[1]],
			bbox: [bbox[0], bbox[1], bbox[2], bbox[3]],
		}

		return { metadata, bands, isGeoreferenced }
	}
}
